import {FirmUserRoleStatus} from '@sollapay/enums';

import type {TeamStatusTab} from '../types';
import type {FirmMemberDTO} from '@sollapay/types';

/** `'all'` matches every non-revoked member — `listByFirm` already excludes revoked rows. */
export function matchesStatusTab(member: FirmMemberDTO, tab: TeamStatusTab): boolean {
  if (tab === 'all') return true;
  return (
    member.status === (tab === 'active' ? FirmUserRoleStatus.ACTIVE : FirmUserRoleStatus.PENDING)
  );
}
